import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const UNIVERSAL_LANG: InjectionToken<string> = new InjectionToken<string>('UNIVERSAL_LANG');
// eslint-disable-next-line @typescript-eslint/naming-convention
export const UNIVERSAL_BASE_HREF: InjectionToken<string | undefined> = new InjectionToken<string | undefined>(
  'UNIVERSAL_BASE_HREF'
);
